import { Component, OnInit, HostListener, Input, ChangeDetectorRef } from "@angular/core";
import { Helpers } from "src/app/services/app.helpers";
import { ToastService } from "src/app/core/toast.service";
import { SocketEvents } from "src/app/services/app.constants";
import { Socket } from "ngx-socket-io";
import { NotificationStatusTypes, NotificationTypes } from "src/app/core/models/NotificationTypes";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { NotificationsService } from "../../notifications/notifications.service";
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from "src/environments/environment";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-header-notifications",
  templateUrl: "./header-notifications.component.html",
  styleUrls: ["./header-notifications.component.scss"]
})
export class HeaderNotificationsComponent implements OnInit {
  isNotificationPopupVisible = false;
  hasUnreadNotifications = false;
  notifications: Array<{ text: string, read: boolean, id: number, data: any, dateStr: string }> = [];
  isLazyLoading = false;
  maxPages = 0;
  itemsPage = 0;
  itemsLimit = 10;
  myProfile: any;
  serverPath = environment.serverPath;
  @Input() smallScreen: boolean;
  private destroy$ = new Subject<void>(); // Create a BehaviorSubject to manage the lifecycle of subscriptions

  constructor(
    private helpers: Helpers,
    private socket: Socket,
    private toastService: ToastService,
    private translateService: TranslateService,
    private router: Router,
    private notificationsService: NotificationsService,
    private authService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.myProfile = this.authService.getLocalProfile();
    this.notifications = [];
    this.socket.fromEvent<any>(SocketEvents.Invitation).pipe(takeUntil(this.destroy$)).subscribe(x => {
      x.profile = x.sender;
      if (x.notificationData) {
        x.notificationData = this.safeParseJSON(x.notificationData);
      }
      if(["event-invitation-accepted","community-invitation-accepted"].includes(x.notificationType)) {
        x.profile = x.notificationData.joinedUser;
      }
      this.toastService.infoMessage(this.getNotificationText(x));
      this.helpers.fixProfileImages(x.profile);
      x.dateStr = this.helpers.getPostedOn(x.createdAt);
      const notification: any = {
        id: x.id,
        data: x,
        read: x.notificationStatus === NotificationStatusTypes.Read,
        text: this.getNotificationText(x),
        dateStr: x.dateStr
      };
      if (x.notificationStatus === NotificationStatusTypes.NotRead) this.hasUnreadNotifications = true;
      this.notifications.unshift(notification);
      this.notifications = [...this.notifications];

    });
    this.socket.fromEvent<any>(SocketEvents.FriendRequest).pipe(takeUntil(this.destroy$)).subscribe(x => {
      // console.log("friend request", x, "get not text",this.getNotificationText(x));
      this.toastService.infoMessage(this.getNotificationText(x), x.profile);
      if (x.notificationData) {
        x.notificationData = this.safeParseJSON(x.notificationData);
        if (x.notificationData.postData) {
          x.notificationData.postData = JSON.parse(x.notificationData.postData);
        }
      }
      x.profile = x.notificationData.otherProfile;
      this.helpers.fixProfileImages(x.profile);
      x.dateStr = this.helpers.getPostedOn(x.createdAt);
      const notification: any = {
        id: x.id,
        data: x,
        read: x.notificationStatus === NotificationStatusTypes.Read,
        text: this.getNotificationText(x),
        dateStr: x.dateStr
      };
      if (x.notificationStatus === NotificationStatusTypes.NotRead) this.hasUnreadNotifications = true;
      this.notifications.unshift(notification);
      this.notifications = [...this.notifications];
    });
    this.socket.fromEvent<any>(SocketEvents.NewPost).pipe(takeUntil(this.destroy$)).subscribe(x => {
      if(this.myProfile.id === x.sender.id) {
        }
      else {
      if(this.getNotificationText(x) === undefined) return;
      this.toastService.infoMessage(this.getNotificationText(x), x.profile);
      if (x.notificationData && typeof x.notificationData === "string") {
        x.notificationData = JSON.parse(x.notificationData);
        if (x.notificationData.postData) {
          x.notificationData.postData = JSON.parse(x.notificationData.postData);
        }
      }

      // this.helpers.fixProfileImages(x.profile);
      x.dateStr = this.helpers.getPostedOn(x.createdAt);
      x.profile.profileImage = this.serverPath + x.sender.profileImage;
      const notification: any = {
        id: x.id,
        data: x,
        read: x.notificationStatus === NotificationStatusTypes.Read,
        text: this.getNotificationText(x),
        dateStr: x.dateStr
      };
      if (x.notificationStatus === NotificationStatusTypes.NotRead) this.hasUnreadNotifications = true;
      this.notifications.unshift(notification);
      this.notifications = [...this.notifications];
    }
    });
    this.socket.fromEvent<any>(SocketEvents.PostUpdated).pipe(takeUntil(this.destroy$)).subscribe(x => {
      // console.log(x, "post updated poses fores to akouw");
      if(this.getNotificationText(x) === undefined) return;
      this.toastService.infoMessage(this.getNotificationText(x), x.profile);
      if (x.notificationData) {
        x.notificationData = x.notificationData;
        if (x.notificationData.postData && typeof x.notificationData.postData === "string") {
          x.notificationData.postData = JSON.parse(x.notificationData.postData);
        }
      }

      this.helpers.fixProfileImages(x.profile);
      x.dateStr = this.helpers.getPostedOn(x.createdAt);
      const notification: any = {
        id: x.id,
        data: x,
        read: x.notificationStatus === NotificationStatusTypes.Read,
        text: this.getNotificationText(x),
        dateStr: x.dateStr,
      };
      if (x.notificationStatus === NotificationStatusTypes.NotRead) this.hasUnreadNotifications = true;
      this.notifications.unshift(notification);
      this.notifications = [...this.notifications];
    });
    this.socket.fromEvent<any>(SocketEvents.UpcomingEvent).pipe(takeUntil(this.destroy$)).subscribe(x => {
      
      x.notificationData = this.safeParseJSON(x.notificationData);
      const NotificationText = this.getNotificationText(x);

      this.toastService.infoMessage(NotificationText);
      this.helpers.fixEventImages(x.notificationData);
      x.dateStr = this.helpers.getPostedOn(x.createdAt);
      const notification: any = {
        id: x.id,
        data: x,
        read: x.notificationStatus === NotificationStatusTypes.Read,
        text: NotificationText,
        dateStr: x.dateStr
      };
      this.notifications.unshift(notification);
      this.notifications = [...this.notifications];
    }
    );
    this.socket.fromEvent<any>(SocketEvents.EventDateUpdated).pipe(takeUntil(this.destroy$)).subscribe(x => {

      x.notificationData = this.safeParseJSON(x.notificationData);
      const notificationText = this.getNotificationText(x);
      this.toastService.infoMessage(notificationText);
      this.helpers.fixEventImages(x.notificationData);
      x.dateStr = this.helpers.getPostedOn(x.createdAt);
      const notification: any = {
        id: x.id,
        data: x,
        read: x.notificationStatus === NotificationStatusTypes.Read,
        text: notificationText,
        dateStr: x.dateStr
      };
      this.notifications.unshift(notification);
      this.notifications = [...this.notifications];
    }
    );
    this.hasUnreadNotifications = false;
    this.getNotifications();
  }
  ngOnDestroy() {
    this.destroy$.next(); // Emit a value to complete all subscriptions
    this.destroy$.complete(); // Complete the destroy$ subject
  }
  deleteNotification(event: any,notification: any) {

  this.notificationsService.deleteNotification(notification.id).subscribe(response => {
    this.notifications = this.notifications.filter(x => x.id !== notification.id);
    if(this.notifications.length === 0) {
      this.getNotifications();
    }
    
  })
  event.stopPropagation();
  }

  private safeParseJSON(data: any): any {
    try {
      while (typeof data === 'string') {
        data = JSON.parse(data);
      }
      return data;
    } catch (error) {
      console.error('Error parsing JSON:', error, data);
      return data; // Return the original data if parsing fails
    }
  }
  onReachEnd(event: any) {
    const innerElement = document.getElementById("notifications-body-container");
    if (!this.isLazyLoading && this.maxPages > this.itemsPage) {
      if (event.target.clientHeight + event.target.scrollTop + 20 > innerElement.offsetHeight) {
        this.itemsPage += 1;
        this.isLazyLoading = true;
        this.getNotifications();
      }
    }
  }

  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    const element = document.getElementById("notifications-container");
    if (element) {
      if (!element.contains(event.target)) {
        this.isNotificationPopupVisible = false;
      }
    }
  }

  getNotifications() {
    this.notificationsService.getNotifications(this.itemsPage, this.itemsLimit).subscribe(response => {
      this.maxPages = Math.ceil(response.count / this.itemsLimit) - 1;
      response.items.forEach(x => {
        if(x.notificationType === 'friend-request' || x.notificationType === 'friends'){
          x.profile = x.notificationData.otherProfile;
        }
        if(x.profile!==undefined){
        this.helpers.fixProfileImages(x.profile);
      }
        else if(x.notificationType.includes("upcoming") || x.notificationType =="event-date-updated"){
          this.helpers.fixEventImages(x.notificationData);
        }
        x.dateStr = this.helpers.getPostedOn(x.createdAt);
        const notification: any = {
          id: x.id,
          data: x,
          notificationType: x.notificationType,
          read: x.notificationStatus === NotificationStatusTypes.Read,
          text: this.getNotificationText(x),
          dateStr: x.dateStr,
        };
        if (x.notificationStatus === NotificationStatusTypes.NotRead) this.hasUnreadNotifications = true;
        this.notifications.push(notification);
      });
      this.isLazyLoading = false;
      this.notifications = [...this.notifications];
    });
  }
  
  getNotificationText(data: any) {
    if (!('notificationType' in data)) { return; }
    if (!data.notificationType) { return undefined; }
    if (data.notificationType === NotificationTypes.NewPost) {
      const text = data.sender ? data.sender : data.profile;
      return this.translateService.instant("headerPage.NewPostFrom", text);
    } else if (data.notificationType === NotificationTypes.Friends) {
      return this.translateService.instant("YouAreNowFriendsWith", data.notificationData.otherProfile);
    } else if (data.notificationType === NotificationTypes.FriendsRequest) {
      return this.translateService.instant("YouHaveAFriendRequestFrom", data.notificationData.otherProfile);
    } else if (data.notificationType === NotificationTypes.Like) {
      return this.translateService.instant("YouHaveNewLikeFrom", data.profile);
    } else if (data.notificationType === NotificationTypes.Comment) {
      return this.translateService.instant("YouHaveNewCommentFrom", data.profile);
    } else if (data.notificationType === NotificationTypes.eventInvitation) {
      return this.translateService.instant("YouHaveNewInvitationFromToEvent", { profile: data.profile, eventName: data.notificationData.name });
    } else if (data.notificationType === NotificationTypes.communityInvitation) {
      return this.translateService.instant("YouHaveNewInvitationFromToCommunity", { profile: data.profile, communityName: data.notificationData.name });
    } else if (data.notificationType === NotificationTypes.eventInvitationAccepted) {
      return this.translateService.instant("UserAcceptedInvitationToEvent", { profile: data.profile, eventName: data.notificationData.name });
    } else if (data.notificationType === NotificationTypes.communityInvitationAccepted) {
      return this.translateService.instant("UserAcceptedInvitationToCommunity", { profile: data.profile, communityName: data.notificationData.name });
    } else if (data.notificationType === NotificationTypes.upComingEventDay) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = data.notificationData.eventDate 
      }
      else {
        if (typeof data.notificationData.eventDate === "string") {
  
          // Check if the date is in ISO format
          const isISO = moment(data.notificationData.eventDate, moment.ISO_8601, true).isValid();
  
          if (!isISO) {
            // Convert to DD/MM/YYYY HH:mm if not ISO

          } else {
            data.notificationData.eventDate = moment(
              data.notificationData.eventDate,
              moment.ISO_8601,
            ).format("DD/MM/YYYY HH:mm");
          }
  
        } else {
          // data.notificationData.eventDate = moment(data.notificationData.eventDate).format("DD/MM/YYYY HH:mm");
        }
    }
      return this.translateService.instant("upcomingEventInDay", data.notificationData);
    } else if (data.notificationType === NotificationTypes.upComingEventHour) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = moment(data.notificationData.eventDate, "MM/DD/YYYY HH:mm").format("HH:mm"); 
      }
      else if(this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = moment(data.notificationData.eventDate).format("HH:mm");
      }
      return this.translateService.instant("upcomingEventInHour", data.notificationData);
    } else if (data.notificationType === NotificationTypes.upComingEventNow) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = moment(data.notificationData.eventDate, "MM/DD/YYYY HH:mm").format("HH:mm"); 
      }
      else if(this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = moment(data.notificationData.eventDate).format("HH:mm");
      }

      return this.translateService.instant("upcomingEventNow", data.notificationData);
    } else if(data.notificationType === NotificationTypes.eventDateUpdated) {
      if(!this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = data.notificationData.eventDate 
      }
      else if(this.isValidDate(data.notificationData.eventDate)) {
        data.notificationData.eventDate = moment(data.notificationData.eventDate).format("DD/MM/YYYY HH:mm");
      }
      return this.translateService.instant("eventDateUpdated", data.notificationData);
    }
  }
   isValidDate(date: any): boolean {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime()); // Returns true if the date is valid
  }
  toggleNotifications() {
    if (!this.isNotificationPopupVisible) {
      this.itemsPage = 0;
      this.notifications = [];
      this.hasUnreadNotifications = false;
      this.getNotifications();
    }
    setTimeout(() => {
    this.isNotificationPopupVisible = !this.isNotificationPopupVisible, 3000});
  }

  markAllAsRead() {
    this.notificationsService.markAllAsRead().subscribe(response => {
      this.notifications.forEach(notification => {
        notification.read = true;
      });
      this.hasUnreadNotifications = false;
    });
  }

  notificationClicked(notification: any) {
    if (!notification.read) {

      let notificationToMark ="";
      if(notification.data.notificationType === NotificationTypes.Like || notification.data.notificationType === NotificationTypes.Comment) {
        notificationToMark = notification.data.notificationId ? notification.data.notificationId : notification.id;
      } else {
        notificationToMark = notification.id;
      }
      this.notificationsService.markNotificationRead(parseInt(notificationToMark)).subscribe(response => {
        notification.read = true;
        this.notifications.find(x => x.id === notification.id).read = true;
      });
    }
    if (notification.data.notificationType === NotificationTypes.NewPost) {
      this.router.navigateByUrl("/post/" + notification.data.notificationData.id);
    } else if (notification.data.notificationType === NotificationTypes.Friends ) {
      this.router.navigateByUrl("/profile/" + notification.data.notificationData.otherProfile.id);
    } else if (notification.data.notificationType === NotificationTypes.FriendsRequest) {
      this.router.navigateByUrl("/profile/" + this.myProfile.id + "/friends");
    } else if(notification.data.notificationType === NotificationTypes.Like) {
      this.router.navigateByUrl("/post/" + notification.data.notificationData.postId);
    } else if(notification.data.notificationType === NotificationTypes.Comment) {
      this.router.navigateByUrl("/post/" + notification.data.notificationData.postId);
    } else if(notification.data.notificationType === NotificationTypes.eventInvitation) {
      this.router.navigateByUrl("/event/" + notification.data.notificationData.id);
    } else if(notification.data.notificationType === NotificationTypes.communityInvitation) {
      this.router.navigateByUrl("/community/" + notification.data.notificationData.id);
    } else if (notification.data.notificationType === NotificationTypes.eventInvitationAccepted) {
      this.router.navigateByUrl("/event/" + notification.data.notificationData.id);
    } else if (notification.data.notificationType === NotificationTypes.communityInvitationAccepted) {
      this.router.navigateByUrl("/community/" + notification.data.notificationData.id);
    } else if (["upcoming-event","upcoming-event-hour","upcoming-event-now","event-date-updated"].includes(notification.data.notificationType)) {
      this.router.navigateByUrl("/event/" + notification.data.notificationData.id);
    }

    this.isNotificationPopupVisible = false;
  }
}
